import { useContext } from 'react';
import { EntityContext } from '../contexts/GroupContext';

export function useEntity() {
  return useContext(EntityContext);
}
